<section class="AmFlightStatusScreen bg-am-medium-blue" [appAmInactive]="'xs'">
  <div class="AmFlightStatusScreen_badgeRow">
    <div class="AmFlightStatusScreen_badge fw-medium-x" [ngClass]="badgeClass">
      <svg
        *ngIf="config.badgeIcon === 'warning'"
        class="AmFlightStatusScreen_badgeIcon"
        viewBox="0 0 98 98"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          class="AmFlightStatusScreen_badgeIconShape"
          d="M90.9729 73.549L57.3589 14.455C53.8309 8.24832 44.8475 8.24832 41.3195 14.455L7.73821 73.549C4.27554 79.6576 8.68554 87.3016 15.7415 87.3016C33.0254 87.3016 59.8954 87.3016 82.9369 87.3016C89.9929 87.3016 94.4682 79.6903 90.9729 73.549Z"
        />
        <path
          class="AmFlightStatusScreen_badgeIconDetail"
          d="M49.3555 30.5596V58.7837"
          stroke-width="6"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          class="AmFlightStatusScreen_badgeIconDetail"
          d="M49.3555 70.4456V71.1642"
          stroke-width="8"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <img
        *ngIf="config.badgeIcon === 'cancel'"
        class="AmFlightStatusScreen_badgeIcon"
        src="assets/images/circleCancel.svg"
        alt=""
      />
      <span>{{ config.badgeLabelKey | translate }}<ng-container *ngIf="badgeTime"> {{ badgeTime }}</ng-container></span>
    </div>
  </div>

  <div class="AmFlightStatusScreen_content">
    <p *ngIf="config.showRoute" class="AmFlightStatusScreen_route">
      {{ departureCity }} <span class="AmFlightStatusScreen_routeArrow">&#8594;</span> {{ arrivalCity }}
    </p>

    <div class="AmFlightStatusScreen_header">
      <app-am-image [name]="airport" size="sm" shape="square" [animated]="true"></app-am-image>
      <div class="AmFlightStatusScreen_headerTexts">
        <h1
          class="AmFlightStatusScreen_title fw-medium-x"
          [innerHTML]="config.titleKey | translate: { cityName: titleDest }"
        ></h1>
        <p *ngIf="config.subtitleKey" class="AmFlightStatusScreen_subtitle">
          {{ config.subtitleKey | translate }}
        </p>
      </div>
    </div>

    <div class="AmFlightStatusScreen_flightData" [class.AmFlightStatusScreen_flightData--struck]="config.strikeTimes">
      <div class="AmFlightStatusScreen_flightMeta">
        <p class="AmFlightStatusScreen_label">{{ 'noticeClose.flight' | translate }}</p>
        <p class="AmFlightStatusScreen_value fw-medium-x">{{ flight }}</p>
      </div>

      <div *ngIf="config.showBoarding" class="AmFlightStatusScreen_flightMeta">
        <p class="AmFlightStatusScreen_label">{{ 'flightStatusScreen.boarding' | translate }}</p>
        <p
          class="AmFlightStatusScreen_value fw-medium-x"
          [ngClass]="timeChangeClass"
          [class.AmFlightStatusScreen_value--now]="config.boardingNow"
        >
          <ng-container *ngIf="config.boardingNow">{{ 'flightStatusScreen.boardingNow' | translate }}</ng-container>
          <ng-container *ngIf="!config.boardingNow">{{ boardingTime }}</ng-container>
        </p>
        <p *ngIf="hasTimeChange && originalBoardingTime" class="AmFlightStatusScreen_timeOld">
          {{ originalBoardingTime }}
        </p>
      </div>

      <div class="AmFlightStatusScreen_timeline">
        <div class="AmFlightStatusScreen_timelinePoint">
          <p class="AmFlightStatusScreen_label">{{ departureAirport }}</p>
          <p class="AmFlightStatusScreen_value AmFlightStatusScreen_time fw-medium-x" [ngClass]="timeChangeClass">
            {{ departureTime | date: 'HH:mm' }}
          </p>
          <p *ngIf="hasTimeChange && originalDepartureTime" class="AmFlightStatusScreen_timeOld">
            {{ originalDepartureTime | date: 'HH:mm' }}
          </p>
        </div>

        <div class="AmFlightStatusScreen_timelineTrack">
          <p class="AmFlightStatusScreen_connections">{{ connections }}</p>
          <div class="AmFlightStatusScreen_line">
            <span class="AmFlightStatusScreen_dot"></span>
            <span class="AmFlightStatusScreen_path"></span>
            <span *ngIf="connections" class="AmFlightStatusScreen_stop"></span>
            <span class="AmFlightStatusScreen_path" [class.d-none]="!connections"></span>
            <span class="AmFlightStatusScreen_dot"></span>
          </div>
          <p class="AmFlightStatusScreen_duration">{{ durationLabel }}</p>
        </div>

        <div class="AmFlightStatusScreen_timelinePoint AmFlightStatusScreen_timelinePoint--right">
          <p class="AmFlightStatusScreen_label">{{ arrivalAirport }}</p>
          <p class="AmFlightStatusScreen_value AmFlightStatusScreen_time fw-medium-x" [ngClass]="timeChangeClass">
            {{ arrivalTime | date: 'HH:mm' }}
          </p>
          <p *ngIf="hasTimeChange && originalArrivalTime" class="AmFlightStatusScreen_timeOld">
            {{ originalArrivalTime | date: 'HH:mm' }}
          </p>
        </div>
      </div>
    </div>

    <div *ngIf="config.helpCards.length" class="AmFlightStatusScreen_help">
      <h2 class="AmFlightStatusScreen_helpTitle fw-medium-x">{{ config.helpTitleKey | translate }}</h2>
      <div *ngFor="let card of config.helpCards" class="AmFlightStatusScreen_card">
        <span
          class="AmFlightStatusScreen_cardIcon AmFlightStatusScreen_cardIcon--{{ card.iconClass }}"
        ></span>
        <div>
          <p class="AmFlightStatusScreen_cardTitle fw-medium-x">{{ card.titleKey | translate }}</p>
          <p class="AmFlightStatusScreen_cardSubtitle">{{ card.subtitleKey | translate }}</p>
        </div>
      </div>
    </div>

    <div *ngIf="config.infoCard" class="AmFlightStatusScreen_card AmFlightStatusScreen_card--info">
      <img class="AmFlightStatusScreen_cardIcon" [src]="config.infoCard.icon" alt="" />
      <div>
        <p class="AmFlightStatusScreen_cardTitle fw-medium-x">{{ config.infoCard.titleKey | translate }}</p>
        <p class="AmFlightStatusScreen_cardSubtitle">{{ infoCardBodyKey | translate }}</p>
      </div>
    </div>
  </div>
</section>
